module.exports = __webpack_public_path__ + "static/media/medal.e1794088.jpeg";